<template>
    <div class="balance-refund-precheck-root">
        <div class="balance-refund-precheck-panel fade-in">
        <MaintCollapsibleBanner
            title="余额退回前置判断"
            icon="el-icon-wallet"
            storage-key="balanceRefundPrecheck"
        >
            <div class="desc-item">
                <span class="desc-badge badge-primary">判断规则</span>
                <span>与 <code>Alipay/Refund</code> 一致：默认仅用<strong>最近两次</strong>成功充值订单的可退金额，判断是否足以覆盖账户余额。</span>
            </div>
            <div class="desc-item">
                <span class="desc-badge badge-warning">跨年扩笔</span>
                <span>扩笔纳入的充值订单若跨<strong>不同自然年</strong>，会标记为「跨年扩笔可退」，请单独筛选并谨慎退款。</span>
            </div>
            <div class="desc-item">
                <span class="desc-badge badge-success">使用建议</span>
                <span>先按班级或姓名筛选并查询；<strong>可退</strong>与<strong>扩笔可退</strong>（含跨年）均可在本页执行余额退回，需超密授权，一次最多 5 人。退款完成后可在<strong>「退款记录」</strong>页查看逐笔明细。</span>
            </div>
        </MaintCollapsibleBanner>

        <el-tabs v-model="activeTab" class="main-tabs" @tab-click="onMainTabClick">
            <el-tab-pane label="前置判断" name="precheck" lazy>
        <section class="query-layout">
            <aside class="dept-filter-pane">
                <div class="dept-filter-header">
                    <i class="el-icon-school"></i>
                    <span>按班级筛选</span>
                </div>
                <DepartmentPane directory-scope="teaching" @tree-node-click="onDeptSelect" @collapse-change="onDeptCollapseChange" />
            </aside>
            <main class="query-main">
                <el-card shadow="never" class="step-card branch-card-teal query-filter-card">
                    <div class="toolbar-filter-bar">
                    <el-form :inline="true" size="small" class="toolbar-filter-form">
                        <div class="toolbar-filter-fields">
                        <el-form-item label="人员类型">
                            <el-radio-group v-model="query.type" @change="onTypeChange">
                                <el-radio :label="0">学生</el-radio>
                                <el-radio :label="1">教师</el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item label="姓名">
                            <el-input v-model="query.name" clearable placeholder="支持模糊查询" class="toolbar-field-w-md" />
                        </el-form-item>
                        <el-form-item label="可退状态">
                            <el-select v-model="query.refundableStatus" clearable placeholder="全部有余额" class="toolbar-field-w-md">
                                <el-option label="全部有余额" value="" />
                                <el-option label="仅可退" value="can" />
                                <el-option label="扩笔可退" value="cannot_extendable" />
                                <el-option label="跨年扩笔可退" value="cross_year" />
                                <el-option label="仅不可退" value="cannot" />
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" icon="el-icon-search" :loading="listLoading" @click="doQuery">查询</el-button>
                        </el-form-item>
                        </div>
                        <div class="toolbar-filter-actions">
                            <el-button size="small" type="warning" icon="el-icon-download" :loading="exportLoading" @click="doExport">导出</el-button>
                        </div>
                    </el-form>
                    </div>
                </el-card>

                <div v-if="summary" class="stat-inline">
                    <span class="stat-inline-item tone-blue">有余额 <strong>{{ summary.TotalWithBalance }}</strong></span>
                    <span class="stat-inline-item tone-green">可自动退 <strong>{{ summary.CanRefundCount }}</strong></span>
                    <span class="stat-inline-item tone-purple">扩笔可退 <strong>{{ summary.ExtendableRefundCount || 0 }}</strong></span>
                    <span class="stat-inline-item tone-indigo">跨年扩笔 <strong>{{ summary.CrossYearExtendableCount || 0 }}</strong></span>
                    <span class="stat-inline-item tone-orange">不可退 <strong>{{ summary.CannotRefundCount }}</strong></span>
                </div>

                <el-card shadow="never" class="step-card branch-card result-list-card">
                    <div slot="header" class="card-header-styled result-header">
                        <div class="result-header-left">
                            <i class="el-icon-tickets"></i>
                            <span>判断结果</span>
                            <span class="header-hint">可退/扩笔可退可勾选，点击行可选中</span>
                        </div>
                        <el-button
                            type="warning"
                            size="small"
                            icon="el-icon-refresh-left"
                            :loading="refundLoading"
                            :disabled="multipleSelection.length === 0"
                            @click="openRefundDialog"
                        >余额退回（已选 {{ multipleSelection.length }}）</el-button>
                    </div>
                    <div class="result-table-host" ref="resultTableHost">
                    <el-table
                        ref="resultTable"
                        :data="list"
                        row-key="UserId"
                        v-loading="listLoading"
                        size="medium"
                        class="custom-table"
                        border
                        :height="resultTableHeight"
                        @selection-change="handleSelectionChange"
                        @row-click="onResultRowClick"
                        :row-class-name="resultRowClassName"
                    >
                        <el-table-column
                            type="selection"
                            width="46"
                            :selectable="rowSelectable"
                        />
                        <el-table-column prop="UserName" label="姓名" width="100" />
                        <el-table-column prop="DeptName" label="部门/班级" min-width="120" show-overflow-tooltip />
                        <el-table-column prop="CardNo" label="卡号" width="120" show-overflow-tooltip />
                        <el-table-column prop="Balance" label="账户余额" width="100" align="right">
                            <template slot-scope="scope">
                                <span class="money-highlight">{{ scope.row.Balance }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="LastTwoOrdersAvailableAmount" label="最近两次可退" width="110" align="right" />
                        <el-table-column prop="ShortfallAmount" label="差额" width="80" align="right">
                            <template slot-scope="scope">
                                <span v-if="scope.row.ShortfallAmount > 0" class="fail-money">{{ scope.row.ShortfallAmount }}</span>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="扩笔提示" width="100" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.ExtraOrdersNeeded > 0" class="extend-hint">
                                    再加{{ scope.row.ExtraOrdersNeeded }}笔
                                </span>
                                <span v-else class="muted-text">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="RequiredOrderCount" label="所需笔数" width="90" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.RequiredOrderCount > 0">{{ scope.row.RequiredOrderCount }}笔</span>
                                <span v-else class="muted-text">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="InvolvedYears" label="涉及年度" width="100" align="center" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.row.InvolvedYears" :class="{ 'cross-year-text': scope.row.IsCrossYear }">
                                    {{ scope.row.InvolvedYears }}
                                </span>
                                <span v-else class="muted-text">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="StatusText" label="状态" width="90" align="center">
                            <template slot-scope="scope">
                                <el-tag size="mini" :type="statusTagType(scope.row.Status)" effect="plain">
                                    {{ scope.row.StatusText }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="Reason" label="判断说明" min-width="220" show-overflow-tooltip />
                        <el-table-column label="充值订单" width="100" align="center">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="hasOrderDetail(scope.row)"
                                    type="text"
                                    size="mini"
                                    @click="showOrders(scope.row)"
                                >查看</el-button>
                                <span v-else class="muted-text">无</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="100" align="center" fixed="right">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="canRefundRow(scope.row)"
                                    type="text"
                                    size="mini"
                                    class="refund-action-btn"
                                    @click="openRefundDialogForRow(scope.row)"
                                >余额退回</el-button>
                                <span v-else class="muted-text">-</span>
                            </template>
                        </el-table-column>
                        <template slot="empty">
                            <div class="table-empty-tip">
                                <i class="el-icon-info"></i>
                                暂无数据，请选择班级或输入姓名后查询
                            </div>
                        </template>
                    </el-table>
                    </div>
                    <div class="pagination-container result-pagination">
                        <el-pagination
                            background
                            layout="total, prev, pager, next, jumper"
                            :page-size="query.intPageSize"
                            :total="total"
                            :current-page.sync="query.page"
                            @current-change="onPageChange"
                        />
                    </div>
                </el-card>
            </main>
        </section>
            </el-tab-pane>

            <el-tab-pane label="退款记录" name="logs" lazy>
        <section class="logs-layout">
            <el-card shadow="never" class="step-card branch-card-teal result-list-card">
                <div slot="header" class="card-header-styled result-header">
                    <div class="result-header-left">
                        <i class="el-icon-time"></i>
                        <span>运维退款记录</span>
                    </div>
                    <el-button size="small" icon="el-icon-refresh" :loading="logListLoading" @click="loadLogList">刷新</el-button>
                </div>
                <div class="toolbar-filter-bar" style="margin-bottom: 12px">
                <el-form :inline="true" class="toolbar-filter-form">
                    <div class="toolbar-filter-fields">
                    <el-form-item label="人员类型">
                        <el-select v-model="logQuery.personType" clearable placeholder="全部" class="toolbar-field-w-sm">
                            <el-option label="全部" :value="-1" />
                            <el-option label="学生" :value="0" />
                            <el-option label="教师" :value="1" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="操作人">
                        <el-input v-model="logQuery.triggerUserName" clearable placeholder="模糊查询" class="toolbar-field-w-md" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" :loading="logListLoading" @click="onLogSearch">查询</el-button>
                    </el-form-item>
                    </div>
                </el-form>
                </div>
                <div class="result-table-host result-table-host--log" ref="logTableHost">
                <el-table
                    ref="logTable"
                    :data="logList"
                    v-loading="logListLoading"
                    size="small"
                    border
                    class="log-record-table"
                    :height="logTableHeight"
                >
                    <el-table-column prop="StartTime" label="执行时间" width="165" />
                    <el-table-column prop="PersonTypeText" label="类型" width="70" align="center" />
                    <el-table-column prop="TriggerUserName" label="操作人" width="100" />
                    <el-table-column prop="TotalCount" label="人数" width="70" align="right" />
                    <el-table-column prop="SuccessCount" label="成功" width="70" align="right" />
                    <el-table-column prop="FailedCount" label="失败" width="70" align="right" />
                    <el-table-column prop="StatusText" label="批次状态" width="90" align="center" />
                    <el-table-column prop="Message" label="汇总" min-width="200" show-overflow-tooltip />
                    <el-table-column label="操作" width="100" align="center">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                size="mini"
                                class="log-detail-link"
                                @click="showLogDetail(scope.row)"
                            >查看明细</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                </div>
                <div class="pagination-container result-pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, jumper"
                        :page-size="logQuery.intPageSize"
                        :total="logTotal"
                        :current-page.sync="logQuery.page"
                        @current-change="onLogPageChange"
                    />
                </div>
            </el-card>
        </section>
            </el-tab-pane>
        </el-tabs>
        </div>

        <el-dialog
            :title="orderDialogTitle"
            :visible.sync="orderDialogVisible"
            width="720px"
            append-to-body
            :modal-append-to-body="true"
            :lock-scroll="true"
            custom-class="balance-refund-ops-dialog"
        >
            <el-table :data="orderDialogRows" size="small" border max-height="360">
                <el-table-column prop="OrderNo" label="订单号" min-width="180" show-overflow-tooltip />
                <el-table-column prop="GmtPayment" label="支付时间" width="165" />
                <el-table-column prop="TotalAmount" label="订单金额" width="95" align="right" />
                <el-table-column prop="RefundAmount" label="已退金额" width="95" align="right" />
                <el-table-column prop="AvailableAmount" label="可退金额" width="95" align="right">
                    <template slot-scope="scope">
                        <span class="money-highlight">{{ scope.row.AvailableAmount }}</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <el-dialog
            title="运维余额退回确认"
            :visible.sync="refundDialogVisible"
            width="480px"
            append-to-body
            :modal-append-to-body="true"
            :lock-scroll="true"
            :close-on-click-modal="false"
            custom-class="balance-refund-ops-dialog balance-refund-ops-dialog--confirm"
        >
            <el-alert
                v-if="hasCrossYearRefundTargets"
                type="error"
                :closable="false"
                show-icon
                title="含跨年扩笔退款"
                description="所选人员纳入订单跨不同自然年，退款将按所需笔数逐单调用支付宝，请核对涉及年度后再确认。"
                style="margin-bottom: 12px"
            />
            <el-alert
                type="warning"
                :closable="false"
                show-icon
                title="超级管理员操作"
                description="将对所选人员执行支付宝退款：可退按最近2笔，扩笔可退按所需笔数，跨年扩笔将单独标记流水。操作不可撤销。"
                style="margin-bottom: 16px"
            />
            <div v-if="refundTargets.length" class="refund-target-list">
                <div v-for="item in refundTargets" :key="item.UserId" class="refund-target-item">
                    <span>{{ item.UserName }}</span>
                    <span class="refund-target-hint">{{ refundTargetHint(item) }}</span>
                </div>
            </div>
            <el-form label-width="100px" size="small" style="margin-top: 16px">
                <el-form-item label="超密授权码" required>
                    <el-input
                        v-model="refundAuthCode"
                        type="password"
                        show-password
                        placeholder="请输入超密授权码"
                        autocomplete="off"
                    />
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="refundDialogVisible = false">取消</el-button>
                <el-button type="danger" :loading="refundLoading" @click="confirmExtendableRefund">确认退款</el-button>
            </div>
        </el-dialog>

        <el-dialog
            :title="logDetailTitle"
            :visible.sync="logDetailVisible"
            width="920px"
            append-to-body
            custom-class="balance-refund-ops-dialog"
        >
            <div v-if="logDetailSummary" class="log-detail-summary">{{ logDetailSummary }}</div>
            <el-form :inline="true" size="small" class="log-detail-filter">
                <el-form-item label="姓名">
                    <el-input
                        v-model="logDetailQuery.name"
                        clearable
                        placeholder="模糊查询"
                        style="width: 120px"
                        @keyup.enter.native="onLogDetailSearch"
                    />
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="logDetailQuery.status" clearable placeholder="全部" style="width: 110px">
                        <el-option label="成功" value="success" />
                        <el-option label="失败" value="failed" />
                        <el-option label="部分成功" value="partial" />
                        <el-option label="跳过" value="skipped" />
                    </el-select>
                </el-form-item>
                <el-form-item label="步骤">
                    <el-select v-model="logDetailQuery.step" clearable placeholder="全部" style="width: 130px">
                        <el-option label="跳过" value="skip" />
                        <el-option label="支付宝失败" value="alipay_fail" />
                        <el-option label="落账成功" value="persist_ok" />
                        <el-option label="落账失败" value="persist_fail" />
                        <el-option label="人员汇总" value="user_summary" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" :loading="logDetailLoading" @click="onLogDetailSearch">查询</el-button>
                    <el-button @click="resetLogDetailFilter">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table :data="logDetailItems" v-loading="logDetailLoading" size="small" border max-height="420">
                <el-table-column label="#" width="50" align="center" :index="logDetailIndexMethod" type="index" />
                <el-table-column prop="UserName" label="姓名" width="90" />
                <el-table-column prop="PrecheckStatusText" label="前置状态" width="110" show-overflow-tooltip />
                <el-table-column prop="Step" label="步骤" width="100" />
                <el-table-column label="笔次" width="70" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.OrderTotalCount">{{ scope.row.OrderIndex }}/{{ scope.row.OrderTotalCount }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="RefundAmount" label="退款额" width="80" align="right" />
                <el-table-column prop="OrderNo" label="订单号" min-width="150" show-overflow-tooltip />
                <el-table-column prop="RefundNo" label="退款请求号" min-width="150" show-overflow-tooltip />
                <el-table-column prop="StatusText" label="状态" width="80" align="center">
                    <template slot-scope="scope">
                        <el-tag size="mini" :type="logStatusTagType(scope.row.Status)" effect="plain">{{ scope.row.StatusText }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="ResultMessage" label="说明" min-width="160" show-overflow-tooltip />
                <el-table-column prop="CreatedTime" label="时间" width="155" />
            </el-table>
            <el-pagination
                v-if="logDetailTotal > 0"
                layout="total, prev, pager, next"
                :page-size="logDetailQuery.intPageSize"
                :total="logDetailTotal"
                :current-page="logDetailQuery.page"
                style="margin-top: 12px; text-align: right"
                @current-change="onLogDetailPageChange"
            />
        </el-dialog>
    </div>
</template>

<script>
import DepartmentPane from '../../../components/DepartmentPane';
import MaintCollapsibleBanner from '../components/MaintCollapsibleBanner';
import { balanceRefundOpsGetPrecheckList, balanceRefundOpsExportPrecheckList, balanceRefundOpsExecuteExtendableRefund, balanceRefundOpsGetRefundBatchLogList, balanceRefundOpsGetRefundBatchLogDetail } from '../../../api/modules/consumption';

/**
 * 余额退回前置判断运维模块。创建于 2026-06-13
 */
export default {
    name: 'BalanceRefundPrecheck',
    components: { DepartmentPane, MaintCollapsibleBanner },
    data() {
        return {
            activeTab: 'precheck',
            query: {
                page: 1,
                name: '',
                type: 0,
                departmentId: '',
                intPageSize: 10,
                refundableStatus: ''
            },
            selectedDeptName: '',
            list: [],
            total: 0,
            summary: null,
            listLoading: false,
            exportLoading: false,
            refundLoading: false,
            multipleSelection: [],
            refundDialogVisible: false,
            refundAuthCode: '',
            refundTargets: [],
            orderDialogVisible: false,
            orderDialogTitle: '充值订单明细',
            orderDialogRows: [],
            logQuery: { page: 1, intPageSize: 10, personType: -1, triggerUserName: '' },
            logList: [],
            logTotal: 0,
            logListLoading: false,
            logDetailVisible: false,
            logDetailTitle: '退款明细',
            logDetailSummary: '',
            logDetailItems: [],
            logDetailQuery: { batchLogId: 0, page: 1, intPageSize: 10, name: '', status: '', step: '' },
            logDetailTotal: 0,
            logDetailLoading: false,
            resultTableHeight: 360,
            logTableHeight: 320
        };
    },
    computed: {
        hasCrossYearRefundTargets() {
            return this.refundTargets.some(x => x.Status === 'cannot_extendable_cross_year');
        }
    },
    mounted() {
        this.scheduleTableHeightSync();
        window.addEventListener('resize', this.scheduleTableHeightSync);
        this.$nextTick(() => this.bindTableHostObserver());
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.scheduleTableHeightSync);
        this.unbindTableHostObserver();
        if (this._tableHeightTimer) {
            clearTimeout(this._tableHeightTimer);
            this._tableHeightTimer = null;
        }
    },
    methods: {
        /** 按宿主容器实测高度同步 el-table，保证表体内滚。最后更新：2026-09-09 */
        scheduleTableHeightSync() {
            if (this._tableHeightTimer) clearTimeout(this._tableHeightTimer);
            this._tableHeightTimer = setTimeout(() => {
                this.syncTableHeights();
            }, 50);
        },
        bindTableHostObserver() {
            if (typeof ResizeObserver === 'undefined') return;
            this.unbindTableHostObserver();
            this._tableHostObserver = new ResizeObserver(() => {
                this.scheduleTableHeightSync();
            });
            const resultHost = this.$refs.resultTableHost;
            if (resultHost) this._tableHostObserver.observe(resultHost);
            const logHost = this.$refs.logTableHost;
            if (logHost) this._tableHostObserver.observe(logHost);
        },
        unbindTableHostObserver() {
            if (this._tableHostObserver) {
                this._tableHostObserver.disconnect();
                this._tableHostObserver = null;
            }
        },
        /** 优先用宿主高度；宿主过小时按视口剩余高度兜底。创建于 2026-09-09 */
        resolveHostTableHeight(host) {
            if (!host) return 0;
            const hostHeight = host.clientHeight;
            if (hostHeight >= 160) return hostHeight;

            const cardBody = host.parentElement;
            if (cardBody && cardBody.clientHeight > 0) {
                let reserved = 12;
                Array.prototype.forEach.call(cardBody.children, (child) => {
                    if (child === host) return;
                    reserved += child.offsetHeight || 0;
                });
                const bodyAvailable = cardBody.clientHeight - reserved;
                if (bodyAvailable >= 160) return bodyAvailable;
            }

            const pagination = this.$el.querySelector('.result-pagination');
            const pagH = pagination ? pagination.offsetHeight : 48;
            const top = host.getBoundingClientRect().top;
            return Math.max(280, Math.floor(window.innerHeight - top - pagH - 28));
        },
        syncTableHeights() {
            this.$nextTick(() => {
                const resultHost = this.$refs.resultTableHost;
                if (resultHost) {
                    const nextHeight = this.resolveHostTableHeight(resultHost);
                    if (nextHeight > 0) this.resultTableHeight = nextHeight;
                }
                const logHost = this.$refs.logTableHost;
                if (logHost) {
                    const nextLogHeight = this.resolveHostTableHeight(logHost);
                    if (nextLogHeight > 0) this.logTableHeight = nextLogHeight;
                }
                const resultTable = this.$refs.resultTable;
                if (resultTable && resultTable.doLayout) resultTable.doLayout();
                const logTable = this.$refs.logTable;
                if (logTable && logTable.doLayout) logTable.doLayout();
            });
        },
        onDeptSelect(data) {
            this.query.departmentId = data.value;
            this.selectedDeptName = data.label;
            this.query.page = 1;
            this.doQuery();
        },
        onTypeChange() {
            this.query.page = 1;
            this.doQuery();
        },
        onPageChange(page) {
            this.query.page = page;
            this.doQuery();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val || [];
        },
        /** 列表行归一化，兼容 PascalCase / camelCase，UserId 转字符串避免雪花 ID 精度丢失。最后修改：2026-06-16 */
        normalizeListRow(row) {
            if (!row) return row;
            const pick = (pascal, camel, def) => (
                row[pascal] != null ? row[pascal] : (row[camel] != null ? row[camel] : def)
            );
            const userId = pick('UserId', 'userId', '');
            return {
                UserId: userId != null ? String(userId) : '',
                UserName: pick('UserName', 'userName', ''),
                DeptName: pick('DeptName', 'deptName', ''),
                DepartmentId: pick('DepartmentId', 'departmentId', 0),
                CardNo: pick('CardNo', 'cardNo', ''),
                Balance: pick('Balance', 'balance', 0),
                LastTwoOrdersAvailableAmount: pick('LastTwoOrdersAvailableAmount', 'lastTwoOrdersAvailableAmount', 0),
                ShortfallAmount: pick('ShortfallAmount', 'shortfallAmount', 0),
                RequiredOrderCount: pick('RequiredOrderCount', 'requiredOrderCount', 0),
                ExtraOrdersNeeded: pick('ExtraOrdersNeeded', 'extraOrdersNeeded', 0),
                RequiredOrdersAvailableAmount: pick('RequiredOrdersAvailableAmount', 'requiredOrdersAvailableAmount', 0),
                IsCrossYear: pick('IsCrossYear', 'isCrossYear', false),
                InvolvedYears: pick('InvolvedYears', 'involvedYears', ''),
                Status: pick('Status', 'status', ''),
                StatusText: pick('StatusText', 'statusText', ''),
                Reason: pick('Reason', 'reason', ''),
                LastTwoOrders: pick('LastTwoOrders', 'lastTwoOrders', []),
                RequiredOrders: pick('RequiredOrders', 'requiredOrders', [])
            };
        },
        canRefundRow(row) {
            const status = row && (row.Status || row.status || '');
            return status === 'can'
                || status === 'cannot_extendable'
                || status === 'cannot_extendable_cross_year';
        },
        rowSelectable(row) {
            return this.canRefundRow(row);
        },
        /** 点击行切换勾选（跳过复选框列、操作按钮） */
        onResultRowClick(row, column, event) {
            if (!this.canRefundRow(row)) return;
            if (column && column.type === 'selection') return;
            if (column && column.label === '操作') return;
            if (event && event.target && (
                event.target.closest('.el-checkbox')
                || event.target.closest('.el-button')
                || event.target.closest('button')
            )) return;
            this.$refs.resultTable.toggleRowSelection(row);
        },
        resultRowClassName({ row }) {
            return this.canRefundRow(row) ? 'row-selectable' : 'row-not-selectable';
        },
        refundTargetHint(item) {
            if (item.Status === 'cannot_extendable_cross_year') {
                return `余额 ${item.Balance} 元 · 跨年扩笔 ${item.RequiredOrderCount} 笔（${item.InvolvedYears}）`;
            }
            if (item.Status === 'cannot_extendable') {
                return `余额 ${item.Balance} 元 · 扩笔需 ${item.RequiredOrderCount} 笔`;
            }
            return `余额 ${item.Balance} 元 · 最近 2 笔可退`;
        },
        openRefundDialog() {
            if (this.multipleSelection.length === 0) {
                this.$message.error('请勾选「可退」「扩笔可退」或「跨年扩笔可退」状态的人员');
                return;
            }
            if (this.multipleSelection.length > 5) {
                this.$message.error('一次最多选择 5 人');
                return;
            }
            this.refundTargets = this.multipleSelection.slice();
            this.refundAuthCode = '';
            this.refundDialogVisible = true;
        },
        openRefundDialogForRow(row) {
            this.refundTargets = [row];
            this.refundAuthCode = '';
            this.refundDialogVisible = true;
        },
        confirmExtendableRefund() {
            if (!this.refundAuthCode) {
                this.$message.error('请输入超密授权码');
                return;
            }
            if (this.refundTargets.length === 0) {
                this.$message.error('未选择退款人员');
                return;
            }
            const userIds = this.refundTargets.map(x => x.UserId);
            const names = this.refundTargets.map(x => x.UserName).join('、');
            const confirmTitle = this.hasCrossYearRefundTargets ? '跨年退款二次确认' : '二次确认';
            const confirmMsg = this.hasCrossYearRefundTargets
                ? `所选人员含跨年扩笔可退，确认对 [${names}] 执行余额退回？请已核对涉及年度。`
                : `确认对 [${names}] 执行余额退回？`;
            this.$confirm(confirmMsg, confirmTitle, { type: 'warning' })
                .then(() => {
                    this.refundLoading = true;
                    balanceRefundOpsExecuteExtendableRefund({
                        AuthCode: this.refundAuthCode,
                        Type: this.query.type,
                        UserIds: userIds
                    }).then(res => {
                        this.refundLoading = false;
                        if (res.data && res.data.success) {
                            const response = res.data.response || {};
                            const batchLogId = response.BatchLogId;
                            this.$message.success(res.data.msg || '操作完成');
                            this.refundDialogVisible = false;
                            this.refundAuthCode = '';
                            this.multipleSelection = [];
                            if (this.$refs.resultTable) {
                                this.$refs.resultTable.clearSelection();
                            }
                            if (response.FailedCount > 0 && response.Items) {
                                const failedMsgs = response.Items
                                    .filter(x => !x.Success)
                                    .map(x => `${x.UserName}: ${x.Msg}`)
                                    .join('；');
                                this.$message.warning(failedMsgs || '部分人员退款失败');
                            }
                            this.doQuery();
                            if (batchLogId) {
                                this.activeTab = 'logs';
                                this.loadLogList();
                                this.$nextTick(() => {
                                    this.showLogDetail({
                                        Id: batchLogId,
                                        Message: response.Message || res.data.msg
                                    });
                                });
                            }
                        } else {
                            this.$message.error((res.data && res.data.msg) || '退款失败');
                        }
                    }).catch(() => {
                        this.refundLoading = false;
                    });
                })
                .catch(() => {});
        },
        doQuery() {
            this.listLoading = true;
            balanceRefundOpsGetPrecheckList(this.query).then(res => {
                this.listLoading = false;
                if (res.data && res.data.success) {
                    const response = res.data.response || {};
                    const rawList = response.Data || response.data || [];
                    this.list = rawList.map(item => this.normalizeListRow(item));
                    this.total = response.DataCount || response.dataCount || 0;
                    this.summary = response.Summary || response.summary || null;
                    this.multipleSelection = [];
                    this.$nextTick(() => {
                        if (this.$refs.resultTable) {
                            this.$refs.resultTable.clearSelection();
                        }
                        this.scheduleTableHeightSync();
                    });
                } else {
                    this.$message.error((res.data && res.data.msg) || '查询失败');
                }
            }).catch(() => {
                this.listLoading = false;
            });
        },
        async doExport() {
            try {
                const para = {
                    name: this.query.name,
                    type: this.query.type,
                    departmentId: this.query.departmentId,
                    refundableStatus: this.query.refundableStatus
                };
                const response = await balanceRefundOpsExportPrecheckList(para);
                if (!response.data || response.data.size === 0) {
                    this.$message.error('导出数据为空');
                    return;
                }
                const typeLabel = this.query.type === 0 ? '学生' : '教师';
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `余额退回前置判断-${typeLabel}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (error) {
                this.$message.error('导出失败');
            }
        },
        statusTagType(status) {
            if (status === 'can') return 'success';
            if (status === 'cannot_extendable') return 'warning';
            if (status === 'cannot_extendable_cross_year') return 'danger';
            if (status === 'cannot') return 'danger';
            if (status === 'jlpay') return 'warning';
            return 'info';
        },
        hasOrderDetail(row) {
            return (row.RequiredOrders && row.RequiredOrders.length) ||
                (row.LastTwoOrders && row.LastTwoOrders.length);
        },
        showOrders(row) {
            if ((row.Status === 'cannot_extendable' || row.Status === 'cannot_extendable_cross_year')
                && row.RequiredOrders && row.RequiredOrders.length) {
                this.orderDialogTitle = `纳入最近 ${row.RequiredOrderCount} 笔充值订单`;
                this.orderDialogRows = row.RequiredOrders;
            } else {
                this.orderDialogTitle = '最近两次充值订单';
                this.orderDialogRows = row.LastTwoOrders || [];
            }
            this.orderDialogVisible = true;
        },
        onMainTabClick(tab) {
            if (tab.name === 'logs') {
                this.loadLogList();
            }
            this.$nextTick(() => {
                this.bindTableHostObserver();
                this.scheduleTableHeightSync();
                setTimeout(() => this.scheduleTableHeightSync(), 200);
            });
        },
        /** 部门树折叠/展开后重算表格高度。创建于 2026-09-09 */
        onDeptCollapseChange() {
            this.scheduleTableHeightSync();
            setTimeout(() => this.scheduleTableHeightSync(), 280);
        },
        onLogSearch() {
            this.logQuery.page = 1;
            this.loadLogList();
        },
        onLogPageChange(page) {
            this.logQuery.page = page;
            this.loadLogList();
        },
        loadLogList() {
            this.logListLoading = true;
            balanceRefundOpsGetRefundBatchLogList(this.logQuery).then(res => {
                this.logListLoading = false;
                if (res.data && res.data.success) {
                    const response = res.data.response || {};
                    this.logList = response.Data || [];
                    this.logTotal = response.DataCount || 0;
                    this.scheduleTableHeightSync();
                }
            }).catch(() => {
                this.logListLoading = false;
            });
        },
        showLogDetail(row) {
            this.logDetailTitle = `退款明细 #${row.Id}`;
            this.logDetailSummary = row.Message || '';
            this.logDetailQuery.batchLogId = row.Id;
            this.logDetailQuery.page = 1;
            this.logDetailQuery.name = '';
            this.logDetailQuery.status = '';
            this.logDetailQuery.step = '';
            this.logDetailVisible = true;
            this.loadLogDetail();
        },
        onLogDetailSearch() {
            this.logDetailQuery.page = 1;
            this.loadLogDetail();
        },
        resetLogDetailFilter() {
            this.logDetailQuery.name = '';
            this.logDetailQuery.status = '';
            this.logDetailQuery.step = '';
            this.logDetailQuery.page = 1;
            this.loadLogDetail();
        },
        onLogDetailPageChange(page) {
            this.logDetailQuery.page = page;
            this.loadLogDetail();
        },
        logDetailIndexMethod(index) {
            return (this.logDetailQuery.page - 1) * this.logDetailQuery.intPageSize + index + 1;
        },
        loadLogDetail() {
            if (!this.logDetailQuery.batchLogId) return;
            this.logDetailLoading = true;
            balanceRefundOpsGetRefundBatchLogDetail(this.logDetailQuery).then(res => {
                this.logDetailLoading = false;
                if (res.data && res.data.success) {
                    const response = res.data.response || {};
                    this.logDetailItems = response.Data || [];
                    this.logDetailTotal = response.DataCount || 0;
                    if (response.Log && response.Log.Message) {
                        this.logDetailSummary = response.Log.Message;
                    }
                } else {
                    this.$message.error((res.data && res.data.msg) || '加载明细失败');
                }
            }).catch(() => {
                this.logDetailLoading = false;
            });
        },
        logStatusTagType(status) {
            if (status === 'success') return 'success';
            if (status === 'failed') return 'danger';
            if (status === 'partial') return 'warning';
            return 'info';
        }
    }
};
</script>

<style scoped>
.balance-refund-precheck-root {
    flex: 1 1 0;
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.balance-refund-precheck-panel {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}

.main-tabs {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.main-tabs >>> .el-tabs__header {
    flex-shrink: 0;
    margin: 0 0 6px !important;
}

.main-tabs >>> .el-tabs__nav-wrap::after {
    height: 1px;
}

.main-tabs >>> .el-tabs__item {
    height: 40px;
    line-height: 40px;
    font-size: 15px;
    font-weight: 600;
    padding: 0 18px !important;
}

.main-tabs >>> .el-tabs__item.is-active {
    font-weight: 700;
}

.main-tabs >>> .el-tabs__content {
    flex: 1;
    min-height: 0;
    height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.main-tabs >>> .el-tab-pane {
    height: 100%;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.logs-layout {
    flex: 1;
    min-height: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0 4px 8px;
}

.logs-layout > .result-list-card {
    flex: 1 1 0;
    min-height: 0;
    margin-bottom: 0 !important;
}

.log-detail-summary {
    margin-bottom: 12px;
    padding: 10px 12px;
    background: #f8fafc;
    border-radius: 6px;
    font-size: 13px;
    color: #475569;
    line-height: 1.5;
}

.log-detail-filter {
    margin-bottom: 8px;
}

::v-deep .log-record-table .log-detail-link {
    padding: 0;
    border: none !important;
    background: transparent !important;
    text-decoration: none;
}

::v-deep .log-record-table .log-detail-link:hover,
::v-deep .log-record-table .log-detail-link:focus {
    text-decoration: none;
    border: none !important;
}

::v-deep .log-record-table .el-table__fixed-right,
::v-deep .log-record-table .el-table__fixed-right-patch {
    display: none;
}

.fade-in {
    animation: fadeIn 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
}

.query-layout {
    flex: 1 1 0;
    min-height: 0;
    height: 0;
    display: flex;
    align-items: stretch;
    gap: 12px;
    overflow: hidden;
}

/* 左侧部门树：对齐全局 .dp-left（264px）；折叠时宽度归零仅留展开浮钮。最后更新：2026-09-09 */
.dept-filter-pane {
    position: relative;
    flex: 0 0 264px;
    width: 264px;
    min-width: 264px;
    max-width: 264px;
    flex-shrink: 0;
    height: 100%;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e2e8f0;
    border-left: 4px solid #6366f1;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
    overflow: hidden;
    box-sizing: border-box;
    transition: all 0.25s ease;
}

.dept-filter-pane.is-collapsed {
    flex: 0 0 0 !important;
    width: 0 !important;
    min-width: 0 !important;
    max-width: 0 !important;
    padding: 0 !important;
    border: none !important;
    margin: 0 !important;
    overflow: visible !important;
    box-shadow: none !important;
    background: transparent !important;
}

.dept-filter-pane.is-collapsed .dept-filter-header {
    display: none !important;
}

.dept-filter-header {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 12px;
    font-weight: 600;
    font-size: 14px;
    color: #1e293b;
    border-bottom: 1px solid #f1f5f9;
    flex-shrink: 0;
}

.dept-filter-header i {
    color: #6366f1;
}

.dept-filter-pane ::v-deep .department-pane {
    flex: 1;
    height: auto;
    min-height: 0;
    border: none;
    border-radius: 0;
    box-shadow: none;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

.dept-filter-pane.is-collapsed ::v-deep .department-pane {
    overflow: visible !important;
}

/* 与同步页统一：深层级节点允许换行，避免班级名被截成省略号。最后更新：2026-09-09 */
.dept-filter-pane ::v-deep .department-pane .el-tree {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #94a3b8 #f1f5f9;
}

.dept-filter-pane ::v-deep .department-pane .el-tree-node__content {
    height: auto;
    min-height: 32px;
    padding-top: 4px;
    padding-bottom: 4px;
}

.dept-filter-pane ::v-deep .tree-node__label {
    white-space: normal;
    word-break: break-all;
    line-height: 1.4;
}

.query-main {
    flex: 1;
    min-width: 0;
    min-height: 0;
    height: 100%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding-right: 4px;
}

.step-card {
    border-radius: 6px !important;
    border: 1px solid #e2e8f0;
    box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
    margin-bottom: 6px;
    flex-shrink: 0;
}

.step-card ::v-deep .el-card__header {
    padding: 6px 10px;
    min-height: auto;
    border-bottom: 1px solid #f1f5f9;
}

.step-card ::v-deep .el-card__body {
    padding: 6px 10px !important;
}

.query-filter-card ::v-deep .el-card__body {
    padding: 4px 8px !important;
}

.query-filter-card ::v-deep .el-form-item {
    margin-bottom: 0;
}

.query-filter-card ::v-deep .el-form-item__label {
    padding-bottom: 0;
    line-height: 32px;
}

.stat-inline {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 14px;
    margin-bottom: 6px;
    padding: 6px 10px;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    flex: 0 0 auto;
}

.stat-inline-item {
    font-size: 13px;
    color: #64748b;
    line-height: 1.4;
}

.stat-inline-item strong {
    font-size: 14px;
    font-weight: 700;
    margin: 0 2px;
    color: #1e293b;
}

.stat-inline-item.tone-blue strong { color: #2563eb; }
.stat-inline-item.tone-green strong { color: #059669; }
.stat-inline-item.tone-purple strong { color: #7c3aed; }
.stat-inline-item.tone-indigo strong { color: #4f46e5; }
.stat-inline-item.tone-orange strong { color: #d97706; }

.stat-dashboard {
    display: none;
}

/* 列表卡必须吃满剩余高度，分页固定在卡片右下角。最后更新：2026-09-09 */
.query-main > .result-list-card,
.logs-layout > .result-list-card,
.result-list-card {
    flex: 1 1 0% !important;
    flex-shrink: 1 !important;
    height: 0 !important;
    min-height: 0 !important;
    margin-bottom: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    overflow: hidden !important;
    box-sizing: border-box;
}

.result-list-card ::v-deep .el-card__header {
    flex: 0 0 auto;
    padding: 6px 10px;
}

.result-list-card ::v-deep .el-card__body {
    flex: 1 1 0% !important;
    height: 0 !important;
    min-height: 0 !important;
    display: flex !important;
    flex-direction: column !important;
    padding: 4px 8px 6px !important;
    box-sizing: border-box;
    overflow: hidden !important;
}

.result-list-card .selection-hint {
    display: none;
}

.result-table-host {
    flex: 1 1 0% !important;
    min-height: 0 !important;
    height: 0 !important;
    overflow: hidden;
    position: relative;
}

.result-table-host--log {
    min-height: 0;
}

.result-table-host ::v-deep .el-table {
    width: 100%;
}

.result-table-host ::v-deep .el-table__body-wrapper {
    overflow-y: auto !important;
    overflow-x: auto !important;
}

.table-empty-tip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #94a3b8;
    font-size: 13px;
    line-height: 1.5;
    padding: 4px 0;
}

.table-empty-tip i {
    color: #94a3b8;
}

.result-list-card ::v-deep .pagination-container,
.result-list-card .result-pagination {
    flex-shrink: 0;
    display: flex !important;
    justify-content: flex-end !important;
    align-items: center !important;
    width: 100%;
    margin-top: 8px !important;
    margin-bottom: 0 !important;
    padding: 4px 0 2px !important;
    min-height: 40px;
}

.branch-card { border-left: 3px solid #6366f1 !important; }
.branch-card-teal { border-left: 3px solid #0d9488 !important; }

.card-header-styled {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    font-size: 14px;
    color: #1e293b;
    line-height: 1.3;
}

.card-header-styled i {
    color: #6366f1;
}

.stat-card {
    position: relative;
    padding: 10px 12px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.05);
}

.stat-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    z-index: 2;
}

.stat-label {
    font-size: 11px;
    font-weight: 600;
}

.stat-value {
    font-size: 18px;
    font-weight: 700;
}

.stat-value .unit {
    font-size: 12px;
    margin-left: 2px;
}

.stat-icon-bg {
    font-size: 28px;
    opacity: 0.12;
    position: absolute;
    right: 10px;
    bottom: 4px;
}

.stat-blue { background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%); color: #1e40af; }
.stat-emerald { background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%); color: #166534; }
.stat-orange { background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%); color: #c2410c; }
.stat-purple { background: linear-gradient(135deg, #f5f3ff 0%, #ede9fe 100%); color: #6d28d9; }
.stat-indigo { background: linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%); color: #4338ca; }

::v-deep .custom-table.el-table th {
    background: #f8fafc !important;
    color: #475569 !important;
    font-weight: 600 !important;
}

.money-highlight {
    font-weight: 600;
    color: #059669;
}

.fail-money {
    color: #dc2626;
    font-weight: 600;
}

.extend-hint {
    color: #7c3aed;
    font-weight: 600;
    font-size: 12px;
}

.cross-year-text {
    color: #dc2626;
    font-weight: 600;
    font-size: 12px;
}

.muted-text {
    color: #94a3b8;
    font-size: 12px;
}

.result-header {
    justify-content: space-between;
}

.result-header-left {
    display: flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
}

.header-hint {
    font-size: 12px;
    font-weight: 400;
    color: #94a3b8;
    margin-left: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.selection-hint {
    display: none;
}

.selection-hint i {
    display: none;
}

::v-deep .custom-table .row-selectable {
    cursor: pointer;
}

::v-deep .custom-table .row-not-selectable {
    cursor: default;
}

.refund-target-list {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 8px 12px;
    max-height: 160px;
    overflow-y: auto;
}

.refund-target-item {
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    font-size: 13px;
    border-bottom: 1px dashed #e2e8f0;
}

.refund-target-item:last-child {
    border-bottom: none;
}

.refund-target-hint {
    color: #94a3b8;
    font-size: 12px;
}

.refund-action-btn {
    color: #d97706 !important;
    font-weight: 600;
}
</style>

<style>
/* 运维弹窗挂 body，统一样式，避免被页面 overflow / 顶栏遮挡 */
.balance-refund-ops-dialog {
    border-radius: 12px;
    overflow: hidden;
}

.balance-refund-ops-dialog .el-dialog__header {
    padding: 16px 20px 12px;
    border-bottom: 1px solid #e2e8f0;
}

.balance-refund-ops-dialog .el-dialog__body {
    padding: 12px 20px 20px;
    max-height: 70vh;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #64748b #f1f5f9;
}

.balance-refund-ops-dialog .el-dialog__body::-webkit-scrollbar {
    width: 6px;
}

.balance-refund-ops-dialog .el-dialog__body::-webkit-scrollbar-thumb {
    background: #64748b;
    border-radius: 4px;
}

.balance-refund-ops-dialog .el-dialog__body::-webkit-scrollbar-thumb:hover {
    background: #475569;
}

.balance-refund-ops-dialog .el-dialog__body::-webkit-scrollbar-track {
    background: #f1f5f9;
}

.balance-refund-ops-dialog .el-table {
    width: 100%;
}

.balance-refund-ops-dialog .el-table__body-wrapper {
    overflow-x: auto;
    scrollbar-width: thin;
    scrollbar-color: #64748b #f1f5f9;
}

.balance-refund-ops-dialog .el-table__body-wrapper::-webkit-scrollbar {
    height: 6px;
}

.balance-refund-ops-dialog .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background: #64748b;
    border-radius: 4px;
}

.balance-refund-ops-dialog--confirm .refund-target-list {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 8px 12px;
    max-height: 160px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: #94a3b8 #f1f5f9;
}

.balance-refund-ops-dialog--confirm .refund-target-list::-webkit-scrollbar {
    width: 6px;
}

.balance-refund-ops-dialog--confirm .refund-target-list::-webkit-scrollbar-thumb {
    background: #94a3b8;
    border-radius: 4px;
}

.balance-refund-ops-dialog--confirm .refund-target-item {
    display: flex;
    justify-content: space-between;
    padding: 6px 0;
    font-size: 13px;
    border-bottom: 1px dashed #e2e8f0;
}

.balance-refund-ops-dialog--confirm .refund-target-item:last-child {
    border-bottom: none;
}

.balance-refund-ops-dialog--confirm .refund-target-hint {
    color: #94a3b8;
    font-size: 12px;
}
</style>
